<template>
    <div class="collapse-root">
        <div class="collapsed-header" ref="collapsedHeader">
            <slot name="small"/>
        </div>
        <div class="expanded-header" ref="expandedHeader">
            <slot name="large"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CollapsingHeader",
        mounted() {
            this.$nextTick(() => {
                const collapsed = this.$refs.collapsedHeader
                const expanded = this.$refs.expandedHeader

                expanded.style.top = `-${collapsed.offsetHeight}px`
                expanded.style.marginBottom = `-${collapsed.offsetHeight}px`
                expanded.style.marginTop = 0
            })
        }
    }
</script>

<style lang="scss" scoped>
    .collapsed-header {
        position: sticky;
        top: 0;
        z-index: 100;
        background-color: inherit;
    }
    .expanded-header {
        position: relative;
        transform: translateZ(1px);
        z-index: 101;
        background-color: inherit;
    }
    .collapse-root {
        display: contents;
        position: relative;
        transform: translateZ(100px);
        background-color: inherit;
    }
</style>
